import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RouteDeliveryScheduleState {
	routeScheduleFormOpen: boolean;
	selectedRouteCode?: string;
}

const initialState: RouteDeliveryScheduleState = {
	routeScheduleFormOpen: false
};

export const routeDeliveryScheduleSlice = createSlice({
	initialState,
	name: "routeDeliverySchedule",
	reducers: {
		closeRouteScheduleForm: (state) => {
			state.routeScheduleFormOpen = false;
			state.selectedRouteCode = undefined;
		},
		openRouteScheduleForm: (state, action: PayloadAction<string | undefined>) => {
			state.selectedRouteCode = action.payload;
			state.routeScheduleFormOpen = true;
		}
	}
});

export const { closeRouteScheduleForm, openRouteScheduleForm } = routeDeliveryScheduleSlice.actions;

export default routeDeliveryScheduleSlice.reducer;
